module.exports = __webpack_public_path__ + "img/section1_larry_the_dog.4e910fb6.svg";